import { toRiskEvent } from './APITransformer';
import type { RiskEvent } from './Types';

import type { DateRange, UUID } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class RiskEventsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getRiskEvents = (period: DateRange, driverId: UUID): Promise<RiskEvent[]> => {
    const requestData: IRequest = {
      endpoint: `/dash/driver/risk-events/${driverId}?start=${period.start}&end=${period.end}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => response.data.risk_events.map(toRiskEvent));
  };
}

export default RiskEventsRequester;
